'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
function init(_ref) {
  var el = _ref.el;

  document.addEventListener('scroll', visibility);
  window.addEventListener('resize', visibility);

  function visibility() {
    var scrollPosition = window.pageYOffset;
    var windowSize = window.innerHeight;
    var bodyHeight = document.body.offsetHeight;

    var distanceFromTop = scrollPosition || (document.documentElement || document.body.parentNode || document.body).scrollTop;
    var distanceFromBottom = Math.max(bodyHeight - (scrollPosition + windowSize), 0);

    if (distanceFromTop >= 200 && distanceFromBottom >= 200) {
      el.setAttribute('aria-hidden', false);
    } else {
      el.setAttribute('aria-hidden', true);
    }
  }
}